import { ArenaPresenter } from '@/presentation/presenters/arena/arenaPresenter'
import { ArenaViewModel } from '@/presentation/viewmodels/arena/arenaViewModel'
import { ProblemStateViewModel } from '@/presentation/viewmodels/problem/problemStateViewModel'

export function useArenaPresenter(
  presenter: ArenaPresenter = new ArenaPresenter(new ArenaViewModel(), new ProblemStateViewModel())
) {
  return {
    arenaId: presenter.arenaId,
    arenaProblemId: presenter.arenaProblemId,
    arenaProblemIndex: presenter.arenaProblemIndex,
    arenaUserEntryList: presenter.arenaUserEntryList,
    arenaProblemElementList: presenter.arenaProblemElementList,
    arenaSolvedProblemList: presenter.arenaSolvedProblemList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    setArenaProblem: presenter.setArenaProblem.bind(presenter),
    getByUserIdArenaEntryList: presenter.getByUserIdArenaEntryList.bind(presenter),
    getArenaDetailData: presenter.getArenaDetailData.bind(presenter)
  }
}
